export default {
    topics: [
        {
            title: ' computeString ',
            href: 'p-CurrentOperator-computeString.html',
            attributes: { 'data-id': 'p-CurrentOperator-computeString' },
            menu: { hasChildren: false },
            tocID: 'p-CurrentOperator-computeString-d66e5934',
            topics: [],
        },
        {
            title: ' groups ',
            href: 'p-CurrentOperator-groups.html',
            attributes: { 'data-id': 'p-CurrentOperator-groups' },
            menu: { hasChildren: false },
            tocID: 'p-CurrentOperator-groups-d66e5942',
            topics: [],
        },
        {
            title: ' hasRight ',
            href: 'm-CurrentOperator-hasRight.html',
            attributes: { 'data-id': 'm-CurrentOperator-hasRight' },
            menu: { hasChildren: false },
            tocID: 'm-CurrentOperator-hasRight-d66e5950',
            topics: [],
        },
        {
            title: ' home ',
            href: 'p-CurrentOperator-home.html',
            attributes: { 'data-id': 'p-CurrentOperator-home' },
            menu: { hasChildren: false },
            tocID: 'p-CurrentOperator-home-d66e5958',
            topics: [],
        },
        {
            title: ' id ',
            href: 'p-CurrentOperator-id.html',
            attributes: { 'data-id': 'p-CurrentOperator-id' },
            menu: { hasChildren: false },
            tocID: 'p-CurrentOperator-id-d66e5966',
            topics: [],
        },
        {
            title: ' login ',
            href: 'p-CurrentOperator-login.html',
            attributes: { 'data-id': 'p-CurrentOperator-login' },
            menu: { hasChildren: false },
            tocID: 'p-CurrentOperator-login-d66e5974',
            topics: [],
        },
        {
            title: ' rights ',
            href: 'p-CurrentOperator-rights.html',
            attributes: { 'data-id': 'p-CurrentOperator-rights' },
            menu: { hasChildren: false },
            tocID: 'p-CurrentOperator-rights-d66e5982',
            topics: [],
        },
        {
            title: ' timezone ',
            href: 'p-CurrentOperator-timezone.html',
            attributes: { 'data-id': 'p-CurrentOperator-timezone' },
            menu: { hasChildren: false },
            tocID: 'p-CurrentOperator-timezone-d66e5990',
            topics: [],
        },
    ],
};

